/**
 * 135编辑器测试页面
 */
"use strict";
angular.module("135editorDemoModule", []).config(['$stateProvider', '$urlRouterProvider', function($stateProvider,
    $urlRouterProvider) {
    $stateProvider.state("135editor", {
        url: "/135editor",
        views: {
            "": {
                template: "<div><div ui-view='head'></div><div new-features='\"\"' style='position:relative;top:60px;width:100%;'><div ng-if='show' editor135></div></div></div>",
                controller: "135editorDemoCtrl"
            },
            'head@135editor': {
                templateUrl: './header_tpl.html',
                controller: 'HeaderController'
            }
        }
    });
    //$urlRouterProvider.otherwise('/login');
    //$urlRouterProvider.otherwise('/front/editctr/iWo/personalManuscript');
}]).
controller("135editorDemoCtrl", ["ueditorService", "$scope", function(ueditorService, $scope) {
    ueditorService.get135Editor().then(function() {
        $scope.show = true;
    });
}]);